import { IUser } from "../IUser";
import { Id } from "@gemma/typescript-types";
import { MutationTree } from "vuex";
import { WireEntities } from "@timesheets/common";

export const mutations: MutationTree<IUser> = {
  mutateHourFormat(
    //
    state: IUser,
    {
      //
      allowUploads,
      recruitmentAgency,
    }: {
      allowUploads: boolean;
      recruitmentAgency: WireEntities.Roles.IRecruitmentAgencyRole<unknown> | Id<string>;
    }
  ) {
    const recruitmentAgencyId = typeof recruitmentAgency === "string" ? recruitmentAgency : recruitmentAgency.id;
    const roles = state.roles.filter(role => role.recruitmentAgency.id === recruitmentAgencyId);
    for (const role of roles) {
      role.recruitmentAgency.settings.documents.allowUploads = allowUploads;
    }
  },
};
